import { createStyles, getStylesRef } from '@mantine/core';
import { ENTITY_NODE_HEADER_HEIGHT } from '../EntityNodeHeader/EntityNodeHeader.constants';
import {
	FETCH_LINEAGE_BUTTON_LABEL_REF,
	FETCH_LINEAGE_BUTTON_RIGHT_ICON_REF,
	FETCH_LINEAGE_BUTTON_WIDTH,
} from './FetchLineageButton.constants';
import type { FetchLineageButtonProps } from './FetchLineageButton.types';

export const useStyles = createStyles(
	(theme, { direction }: Pick<FetchLineageButtonProps, 'direction'>) => {
		const left =
			direction === 'UPSTREAM'
				? `calc(-${theme.other.space[16]}px)`
				: undefined;
		const right =
			direction === 'DOWNSTREAM'
				? `calc(-${theme.other.space[16]}px)`
				: undefined;

		return {
			root: {
				position: 'absolute',
				top: ENTITY_NODE_HEADER_HEIGHT / 4,
				left,
				right,
				minWidth: FETCH_LINEAGE_BUTTON_WIDTH,
				'&:hover': {
					[`& .${getStylesRef(FETCH_LINEAGE_BUTTON_LABEL_REF)}`]: {
						visibility: 'visible',
						width: 'auto',
					},
					[`& .${getStylesRef(FETCH_LINEAGE_BUTTON_RIGHT_ICON_REF)}`]: {
						visibility: 'hidden',
						width: 0,
					},
				},
			},
			rightIcon: {
				ref: getStylesRef(FETCH_LINEAGE_BUTTON_RIGHT_ICON_REF),
				marginLeft: 0,
			},
			label: {
				ref: getStylesRef(FETCH_LINEAGE_BUTTON_LABEL_REF),
				visibility: 'hidden',
				width: 0,
				color: theme.other.getColor('text/secondary/default'),
			},
		};
	}
);
